import C from '../../constants';

export const credit = (state = {}, action) => {
    switch (action.type) {
        case C.SET_CREDIT_EXAM:
            return {
                ...state,
                exam: action.payload
            };

        case C.SET_CREDIT_EXAM_STATUS:
            return {
                ...state,
                exam: {
                    ...state.exam,
                    Evaluation: action.payload
                }
            };

        default:
            return state;
    }

};


// WEBPACK FOOTER //
// ./src/store/reducers/creditReducer.js